import { useState, useCallback, useRef } from 'react';

const useToast = () => {
  const [toastMessage, setToastMessage] = useState('');
  const [toastType, setToastType] = useState('info');
  const timeoutRef = useRef(null);

  const showToast = useCallback((msg, type = 'info') => {
    setToastMessage(msg);
    setToastType(type);
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    timeoutRef.current = setTimeout(() => {
      setToastMessage('');
      setToastType('info');
    }, 3000);
  }, []);

  return { toastMessage, toastType, showToast };
};

export default useToast;
